function Backdrop(props) {
  return (
    <div
      className={`bg-black/70 fixed top-0 left-0 w-full items-center justify-center z-30 h-full ${
        props.show ? 'flex' : 'hidden'
      }`}
      onClick={props.onClick}
      style={props.style}
    >
      {props.element}
    </div>
  );
}

export default Backdrop;
